import { LocaleSupported } from '../localization/setup';
import { assertNever } from './utils';

export const OURA_MEMBERSHIP_HUB_SUBDOMAIN = 'membership';
export const OURA_MEMBERSHIP_HUB_URL = `https://${OURA_MEMBERSHIP_HUB_SUBDOMAIN}.ouraring.com`;
export const OURA_SUPPORT_MEMBERSHIP_URL =
  'https://support.ouraring.com/hc/en-us/articles/4409086524819-Oura-Membership-FAQs';

function localePathForTerms(locale: LocaleSupported) {
  switch (locale) {
    case 'es':
    case 'fi':
    case 'de':
    case 'fr':
    case 'it':
      return `/${locale}`;
    case 'ja':
      // TODO: remove this special case once ecom has the redirect in place for ToS
      return '/jp';
    case 'en':
      return '';
    default:
      assertNever(locale);
      return '';
  }
}

export function privacyPolicyURL(locale: LocaleSupported = 'en') {
  return `${ecomSiteURL('/privacy-policy-oura-health')}${localePathForTerms(
    locale,
  )}`;
}

export function teamsPrivacyPolicyURL(locale: LocaleSupported = 'en') {
  return `${privacyPolicyURL(locale)}#oura-teams-section`;
}

export function termsOfUseURL(locale: LocaleSupported = 'en') {
  return `${ecomSiteURL('/terms-and-conditions')}${localePathForTerms(locale)}`;
}

/**
 * Helper to get environment aware URL for the ecom site (ouraring.com) with an
 * optional path.
 *
 * e.g. (environment -> base URL): localhost:3000 -> ouraring.com
 * cloud.ouraring.com -> ouraring.com cloud.ourastaging.com -> ourastaging.com
 * cloud.ourasandbox.com -> ourasandbox.com
 */
export function ecomSiteURL(path?: string) {
  if (window.location.hostname === 'localhost') {
    const url = new URL('https://ouraring.com');
    if (path) {
      url.pathname = path;
    }
    return url.toString();
  }

  // Remove subdomain.
  const hostname = window.location.hostname.split('.').slice(-2).join('.');
  const url = new URL(`https://${hostname}`);
  if (path) {
    url.pathname = path;
  }
  return url.toString();
}

/**
 * Helper to get environment aware URL for the Membership Hub with an optional
 * path.
 *
 * e.g. (environment -> base URL): localhost:3000 -> membership.ouraring.com
 * cloud.ouraring.com -> membership.ouraring.com cloud.ourastaging.com ->
 * membership.ourastaging.com cloud.ourasandbox.com ->
 * membership.ourasandbox.com
 */
export function membershipHubURL(path?: string) {
  if (window.location.hostname === 'localhost') {
    const url = new URL(OURA_MEMBERSHIP_HUB_URL);
    if (path) {
      url.pathname = path;
    }
    return url.toString();
  }

  const hostParts = window.location.hostname.split('.');
  if (hostParts.length > 2) {
    // Replace the subdomain with the Membership Hub subdomain.
    hostParts[0] = OURA_MEMBERSHIP_HUB_SUBDOMAIN;
  } else {
    // If there is no subdomain, add the Membership Hub subdomain.
    hostParts.unshift(OURA_MEMBERSHIP_HUB_SUBDOMAIN);
  }
  const url = new URL(`https://${hostParts.join('.')}`);
  if (path) {
    url.pathname = path;
  }
  return url.toString();
}
